"use client";
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";
import { countiesLookup } from "utils/filtersData";

export default function Elements() {
  return (
	<div className="cpr_container">
			<div className="cpr_content">
				<div className="cpr_content_inner">
						
	<div className="container pt-5">
		<div className="pt-5 mt-5">
			<h3 className="mb-3">Status Labels</h3>
			<div className="pt-3 pb-3">
				<div className="label label--forsale">Active</div>
				<br /><br />
				<div className="label label--undercontract ">Under Contract - OP</div>
				<br /><br />
				<div className="label label--undercontract">Under Contract – PS</div>
				<br /><br />
				<div className="label label--undercontract">Under Contract – P</div>
				<br /><br />
				<div className="label label--sold">Sold/Rented</div>
				<br /><br />
			</div>
		</div>


		

		<div className="pt-5 mt-5 pb-5 mb-5">
			<h3 className="mb-3">View More Properties</h3>
			
			{/* Empty Card to view more */}	
			<div className="cardv2 cardv2--portrait mb-0 h-100 empty_card cursor--pointer">
				<div>view more properties</div>
			</div>

		</div>


	</div>

			</div>
		</div>


		{/* 
		filters overlay start here 
		Note: when implementing plz remove inline style display:block 
		*/}
		<div className="search_overlay" style={{display:'block'}}>
			<div className="property_window">
				<div className="pw_header d-flex mb-1 pl-4 align-items-center">
				<div className="font_size--large font_weight--bold">Search Filters</div>
				<a className="ml-auto m-3 close_filter_win" href="#">
					<img src="https://content.harstatic.com/media/icons/close_black.svg" />
				</a>
				</div>
				<div className="px-4 pb-4">
				<label className="mb-1" htmlFor="city_id">
					City
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="city_id"
					name="city"
					placeholder="City"
				/>
				<label className="mb-1" htmlFor="EnterZipCode">
					Zip Code
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="city_id"
					name="EnterZipCode"
					placeholder="Enter Zip Code"
				/>
				<label className="mb-1" htmlFor="Subdivisions">
					Subdivisions
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="city_id"
					name="Subdivisions"
					placeholder="Subdivisions"
				/>
				<label className="mb-1" htmlFor="Address">
					Address
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="city_id"
					name="Address"
					placeholder="Address"
				/>
				<label className="mb-1" htmlFor="County">
					County
				</label>
				<select
					data-bitmask={0}
					className="selectpicker  highlight  KeyMap custom-select nfilter custom-select_medium mb-3"
					id="fips_code_id"
					autoComplete="off"
					name="fips_code"
				>
					{countiesLookup.map(({ value, label }) => (
						<option key={value} value={value}>
							{label}
						</option>
					))}
				</select>
				<label className="mb-1" htmlFor="MLSNumber">
					MLS Number
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="city_id"
					name="MLSNumber"
					placeholder="MLS Number"
				/>
				<label className="mb-1" htmlFor="MLSMarketArea">
					MLS Market Area
				</label>
				<select
					data-bitmask={0}
					className="custom-select custom-select_medium nfilter mb-3"
					id="marketarea_id"
					name="marketarea"
				>
					<option value="">All Areas</option>
					<option value="1960/Cypress">1960/Cypress</option>
					<option value="1960/Cypress Creek North">
					1960/Cypress Creek North
					</option>
					<option value="1960/Cypress Creek South">
					1960/Cypress Creek South
					</option>
					<option value="Aldine Area">Aldine Area</option>
					<option value="Alief">Alief</option>
					<option value="Alvin North">Alvin North</option>
					<option value="Alvin South">Alvin South</option>
					<option value="Angelina County">Angelina County</option>
					<option value="Angleton">Angleton</option>
					<option value="Atascocita North">Atascocita North</option>
					<option value="Atascocita South">Atascocita South</option>
					<option value="Bacliff/San Leon">Bacliff/San Leon</option>
					<option value="Bayou Vista">Bayou Vista</option>
					<option value="Baytown/Chambers County">Baytown/Chambers County</option>
					<option value="Baytown/Harris County">Baytown/Harris County</option>
					<option value="Bear Creek South">Bear Creek South</option>
					<option value="Bellaire Area">Bellaire Area</option>
					<option value="Braeswood Place">Braeswood Place</option>
					<option value="Brays Oaks">Brays Oaks</option>
					<option value="Briar Hollow">Briar Hollow</option>
					<option value="Briargrove">Briargrove</option>
					<option value="Briargrove Park/Walnutbend">
					Briargrove Park/Walnutbend
					</option>
					<option value="Briarmeadow/Tanglewilde">Briarmeadow/Tanglewilde</option>
					<option value="Brookshire">Brookshire</option>
					<option value="Caplen">Caplen</option>
					<option value="Chambers County East">Chambers County East</option>
					<option value="Chambers County West">Chambers County West</option>
					<option value="Champions Area">Champions Area</option>
					<option value="Charnwood/Briarbend">Charnwood/Briarbend</option>
					<option value="Clear Lake Area">Clear Lake Area</option>
					<option value="Cleveland Area">Cleveland Area</option>
					<option value="Clute">Clute</option>
					<option value="Coldspring/South San Jacinto County">
					Coldspring/South San Jacinto County
					</option>
					<option value="Conroe Northeast">Conroe Northeast</option>
					<option value="Conroe Southeast">Conroe Southeast</option>
					<option value="Conroe Southwest">Conroe Southwest</option>
					<option value="Copperfield Area">Copperfield Area</option>
					<option value="Cottage Grove">Cottage Grove</option>
					<option value="Crosby Area">Crosby Area</option>
					<option value="Crystal Beach">Crystal Beach</option>
					<option value="Cypress North">Cypress North</option>
					<option value="Cypress South">Cypress South</option>
					<option value="Danbury">Danbury</option>
					<option value="Dayton">Dayton</option>
					<option value="Deer Park">Deer Park</option>
					<option value="Denver Harbor">Denver Harbor</option>
					<option value="Dickinson">Dickinson</option>
					<option value="Downtown - Houston">Downtown - Houston</option>
					<option value="Downtown -Galveston/The Strand">
					Downtown -Galveston/The Strand
					</option>
					<option value="East Beach">East Beach</option>
					<option value="East End">East End</option>
					<option value="East End Revitalized">East End Revitalized</option>
					<option value="Eldridge North">Eldridge North</option>
					<option value="Energy Corridor">Energy Corridor</option>
					<option value="Fall Creek Area">Fall Creek Area</option>
					<option value="Five Corners">Five Corners</option>
					<option value="Fort Bend County North/Richmond">
					Fort Bend County North/Richmond
					</option>
					<option value="Fort Bend South/Richmond">
					Fort Bend South/Richmond
					</option>
					<option value="Fort Bend Southeast">Fort Bend Southeast</option>
					<option value="Freeport">Freeport</option>
					<option value="Friendswood">Friendswood</option>
					<option value="Fulshear/South Brookshire/Simonton">
					Fulshear/South Brookshire/Simonton
					</option>
					<option value="Galleria">Galleria</option>
					<option value="Garden Oaks">Garden Oaks</option>
					<option value="Gilchrist">Gilchrist</option>
					<option value="Greenway Plaza">Greenway Plaza</option>
					<option value="Gulfton">Gulfton</option>
					<option value="Harborside">Harborside</option>
					<option value="Harborwalk">Harborwalk</option>
					<option value="Heights/Greater Heights">Heights/Greater Heights</option>
					<option value="Hempstead">Hempstead</option>
					<option value="High Island">High Island</option>
					<option value="Highland Bayou">Highland Bayou</option>
					<option value="Highland Village/Midlane">
					Highland Village/Midlane
					</option>
					<option value="Hitchcock">Hitchcock</option>
					<option value="Hobby Area">Hobby Area</option>
					<option value="Hockley">Hockley</option>
					<option value="Huffman Area">Huffman Area</option>
					<option value="Humble Area East">Humble Area East</option>
					<option value="Humble Area South">Humble Area South</option>
					<option value="Humble Area West">Humble Area West</option>
					<option value="Jersey Village">Jersey Village</option>
					<option value="Katy - North">Katy - North</option>
					<option value="Katy - Old Towne">Katy - Old Towne</option>
					<option value="Katy - Southeast">Katy - Southeast</option>
					<option value="Katy - Southwest">Katy - Southwest</option>
					<option value="Kingwood East">Kingwood East</option>
					<option value="Kingwood NW/Oakhurst">Kingwood NW/Oakhurst</option>
					<option value="Kingwood South">Kingwood South</option>
					<option value="Kingwood West">Kingwood West</option>
					<option value="Knollwood/Woodside Area">Knollwood/Woodside Area</option>
					<option value="La Marque">La Marque</option>
					<option value="La Porte/Shoreacres">La Porte/Shoreacres</option>
					<option value="Lake Conroe Area">Lake Conroe Area</option>
					<option value="Lake Jackson">Lake Jackson</option>
					<option value="Lake Livingston Area">Lake Livingston Area</option>
					<option value="League City">League City</option>
					<option value="Liberty">Liberty</option>
					<option value="Liberty County East">Liberty County East</option>
					<option value="Livingston Area">Livingston Area</option>
					<option value="Lomax Area">Lomax Area</option>
					<option value="Magnolia/1488 East">Magnolia/1488 East</option>
					<option value="Magnolia/1488 West">Magnolia/1488 West</option>
					<option value="Medical Center Area">Medical Center Area</option>
					<option value="Medical Center South">Medical Center South</option>
					<option value="Memorial Close In">Memorial Close In</option>
					<option value="Memorial Park">Memorial Park</option>
					<option value="Memorial Villages">Memorial Villages</option>
					<option value="Memorial West">Memorial West</option>
					<option value="Meyerland Area">Meyerland Area</option>
					<option value="Midtown - Galveston">Midtown - Galveston</option>
					<option value="Midtown - Houston">Midtown - Houston</option>
					<option value="Mission Bend Area">Mission Bend Area</option>
					<option value="Missouri City Area">Missouri City Area</option>
					<option value="Montgomery County Northwest">
					Montgomery County Northwest
					</option>
					<option value="Montrose">Montrose</option>
					<option value="Near West End">Near West End</option>
					<option value="New Wavery Area">New Waverly Area</option>
					<option value="North Channel">North Channel</option>
					<option value="Northeast Houston">Northeast Houston</option>
					<option value="Northside">Northside</option>
					<option value="Northwest Houston">Northwest Houston</option>
					<option value="Oak Forest East Area">Oak Forest East Area</option>
					<option value="Oak Forest West Area">Oak Forest West Area</option>
					<option value="Omega Bay">Omega Bay</option>
					<option value="Other">Other</option>
					<option value="Pasadena">Pasadena</option>
					<option value="Pearland">Pearland</option>
					<option value="Plantersville Area">Plantersville Area</option>
					<option value="Polk County North">Polk County North</option>
					<option value="Port Bolivar">Port Bolivar</option>
					<option value="Porter/New Caney East">Porter/New Caney East</option>
					<option value="Porter/New Caney West">Porter/New Caney West</option>
					<option value="Rice Military/Washington Corridor">
					Rice Military/Washington Corridor
					</option>
					<option value="Rice/Museum District">Rice/Museum District</option>
					<option value="Richwood">Richwood</option>
					<option value="River Oaks Area">River Oaks Area</option>
					<option value="River Oaks Shopping Area">
					River Oaks Shopping Area
					</option>
					<option value="Rivercrest">Rivercrest</option>
					<option value="Riverside">Riverside</option>
					<option value="Rosharon">Rosharon</option>
					<option value="Royden Oaks/Afton Oaks">Royden Oaks/Afton Oaks</option>
					<option value="Santa Fe">Santa Fe</option>
					<option value="Sharpstown Area">Sharpstown Area</option>
					<option value="Shepherd Park Plaza Area">
					Shepherd Park Plaza Area
					</option>
					<option value="Shoreacres/La Porte">Shoreacres/La Porte</option>
					<option value="Sienna Area">Sienna Area</option>
					<option value="South Houston">South Houston</option>
					<option value="Southbelt/Ellington">Southbelt/Ellington</option>
					<option value="Spring Branch">Spring Branch</option>
					<option value="Spring East">Spring East</option>
					<option value="Spring Northeast">Spring Northeast</option>
					<option value="Spring/Klein">Spring/Klein</option>
					<option value="Spring/Klein/Tomball">Spring/Klein/Tomball</option>
					<option value="Stafford Area">Stafford Area</option>
					<option value="Sugar Land East">Sugar Land East</option>
					<option value="Sugar Land North">Sugar Land North</option>
					<option value="Sugar Land South">Sugar Land South</option>
					<option value="Sugar Land West">Sugar Land West</option>
					<option value="Summerwood/Lakeshore">Summerwood/Lakeshore</option>
					<option value="Surfside">Surfside</option>
					<option value="Tanglewood Area">Tanglewood Area</option>
					<option value="Teichman/Channelview Area">
					Teichman/Channelview Area
					</option>
					<option value="Texas City">Texas City</option>
					<option value="Tiki Island">Tiki Island</option>
					<option value="Timbergrove/Lazybrook">Timbergrove/Lazybrook</option>
					<option value="Tomball">Tomball</option>
					<option value="Tomball South/Lakewood">Tomball South/Lakewood</option>
					<option value="Tomball Southwest">Tomball Southwest</option>
					<option value="Treasure Island">Treasure Island</option>
					<option value="Trinity Area">Trinity Area</option>
					<option value="Tyler County">Tyler County</option>
					<option value="University Area">University Area</option>
					<option value="Upper Kirby">Upper Kirby</option>
					<option value="Waller">Waller</option>
					<option value="Washington East/Sabine">Washington East/Sabine</option>
					<option value="Webster">Webster</option>
					<option value="West End">West End</option>
					<option value="West of the Brazos">West of the Brazos</option>
					<option value="West University/Southside Area">
					West University/Southside Area
					</option>
					<option value="Westchase Area">Westchase Area</option>
					<option value="Willis Area">Willis Area</option>
					<option value="Willow Meadows Area">Willow Meadows Area</option>
					<option value="Willowbrook South">Willowbrook South</option>
					<option value="Winrock">Winrock</option>
					<option value="The Woodlands">The Woodlands</option>
				</select>
				<label className="mb-1" htmlFor="KeyMap">
					Key Map
				</label>
				<input
					type="text"
					className="form-control form-control--small mb-3"
					id="KeyMap"
					name="KeyMap"
					placeholder="Key Map"
				/>
				<label className="mb-1" htmlFor="MLSArea">
					MLS Area
				</label>
				<select
					data-bitmask={0}
					className="custom-select custom-select_medium nfilter mb-3"
					id="MLSArea"
					name="MLSArea"
				>
					<option> Option 1</option>
					<option> Option 2</option>
					<option> Option 3</option>
				</select>
				<label className="mb-1" htmlFor="Criteria">
					Criteria
				</label>
				<div className="row mb-5">
					<div className="col-auto pb-4 pb-md-5" id="forms_for_sale">
					<div
						role="radiogroup"
						className="type__toggle"
						style={{ maxWidth: 282 }}
					>
						<div
						role="radio"
						className="custom-control custom-radio custom-radio__forsale custom-control-inline"
						id="fdiv1"
						>
						<input
							type="radio"
							id="for_sale_id"
							defaultValue={1}
							name="for_sale"
							data-bitmask={0}
							className="custom-control-input"
						/>
						<label
							className="custom-control-label"
							htmlFor="for_sale_id"
							id="for_salebutton"
						>
							For Sale
						</label>
						</div>
						<div
						role="radio"
						className="custom-control custom-radio custom-radio__forrent custom-control-inline"
						id="fdiv2"
						>
						<input
							type="radio"
							id="for_rent_id"
							defaultValue={0}
							name="for_sale"
							data-bitmask={0}
							className="custom-control-input"
						/>
						<label
							className="custom-control-label"
							htmlFor="for_rent_id"
							id="for_rentbutton"
						>
							For Rent
						</label>
						</div>
					</div>
					</div>
				</div>
				</div>
				<div
				className="position-sticky bg_color_snow_white p-3"
				style={{ bottom: 0 }}
				>
				<div className="row small-gutters">
					<div className="col-6">
					<a href="#" className="btn btn--primary btn--large w-100">
						Refine
					</a>
					</div>
					<div className="col-6">
					<a href="#" className="btn btn--ordinary btn--large w-100">
						More Filters
					</a>
					</div>
				</div>
				</div>
			</div>
			</div>


		{/* property overlay closed here */}
	</div>
  );
}
